import { useEffect } from 'react';
import { useCheckout } from '../../../iBuyMobile.context';

export const useVoucheDefault = () => {
  const { product, voucher, setVoucher } = useCheckout();

  useEffect(() => {
    if (product.vouchers?.enableDefaultVoucher) {
      if (
        voucher.voucherId === product?.vouchers?.defaultVoucher &&
        voucher.validateVoucher?.isSuccess &&
        !voucher.isAppliedVoucher
      ) {
        setVoucher({
          ...voucher,
          isApplyVoucher: true,
        });
      }
    }
  }, [voucher.validateVoucher?.isSuccess]);

  useEffect(() => {
    if (product.vouchers?.enableDefaultVoucher) {
      if (voucher.voucherId === '' || voucher.voucherId !== product?.vouchers?.defaultVoucher) {
        setVoucher({
          ...voucher,
          voucherId: product?.vouchers?.defaultVoucher,
        });
      }
    }
  }, []);
};

